/** 出力予想カードの採点（クライアント。card-schema.md §3.1） */
import { normalizeOutput } from '../normalize';
import type { GradeResult, PredictOutputCard } from '../types';

export type PredictAnswer =
  { kind: 'output'; text: string } | { kind: 'compile-error' } | { kind: 'runtime-error' };

export const FIXED_CHOICES = [
  { kind: 'compile-error', label: 'コンパイルエラー' },
  { kind: 'runtime-error', label: '実行時エラー' },
] as const;

function firstDifferentLine(expected: string, actual: string): number {
  const e = normalizeOutput(expected).split('\n');
  const a = normalizeOutput(actual).split('\n');
  const n = Math.max(e.length, a.length);
  for (let i = 0; i < n; i++) if (e[i] !== a[i]) return i + 1;
  return 1;
}

const AGAIN = 'このカードはあとでもう一度出ます。';

export function gradePredictOutput(card: PredictOutputCard, answer: PredictAnswer): GradeResult {
  const outcome = card.outcome ?? 'ok';
  const expected = card.expected ?? '';

  if (outcome === 'ok') {
    if (answer.kind === 'output') {
      if (normalizeOutput(answer.text) === normalizeOutput(expected)) {
        return { verdict: 'AC', message: '出力が一致しました。' };
      }
      const line = firstDifferentLine(expected, answer.text);
      return {
        verdict: 'WA',
        expected,
        actual: answer.text,
        message: `${line} 行目が異なります。${AGAIN}`,
      };
    }
    return {
      verdict: 'WA',
      expected,
      message: `このコードはコンパイルでき、最後まで実行されます。${AGAIN}`,
    };
  }

  if (answer.kind === outcome) {
    return {
      verdict: 'AC',
      message:
        outcome === 'compile-error'
          ? 'コンパイルできないコードです。'
          : '実行の途中で止まるコードです。',
    };
  }
  return {
    verdict: 'WA',
    message:
      outcome === 'compile-error'
        ? `このコードはコンパイルできません。${AGAIN}`
        : `このコードは実行の途中で止まります。${AGAIN}`,
  };
}

/** 自由入力のとき、複数行の textarea にするか */
export function isMultiline(card: PredictOutputCard): boolean {
  return normalizeOutput(card.expected ?? '').includes('\n');
}
